/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListSignersRequest = {
  properties: {
    hirerId: {
      type: 'string',
    },
    hiredCNPJ: {
      type: 'string',
    },
    type: {
      type: 'SignerType',
    },
  },
} as const;
